// Light/dark mode plumbing. The mode lives as `data-theme` on <html>
// (the CSS variables in static/styles/base.scss key off it) and is
// persisted in localStorage. src/index.js applies the stored mode
// before the app renders so there is no light-mode flash.

const STORAGE_KEY = 'theme'

// Dark is the default: only an explicit 'light' choice (or no storage
// access at all, e.g. private mode) falls back to the other mode.
export const getStoredThemeMode = () => {
	try {
		return window.localStorage.getItem( STORAGE_KEY ) === 'light' ? 'light' : 'dark'
	} catch ( e ) {
		return 'dark'
	}
}

export const applyThemeMode = mode => {
	document.documentElement.dataset.theme = mode
	try {
		window.localStorage.setItem( STORAGE_KEY, mode )
	} catch ( e ) {
		// Private mode / storage disabled — the toggle still works for
		// the current page view, it just won't persist.
	}
}
